import Vue from "vue"
import config from '../config'

export default {
    getList() {
        return Vue.http.get(config.apiBaseUrl + '/company-user-invites').then((response) => response.json())
    },

    remove(inviteKey, params = {}) {
        return Vue.http.delete(config.apiBaseUrl + '/company-user-invites/' + inviteKey, { params }).then(response => response.json())
    },

    createInvitation(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/company-user-invites/', body, { params }).then((response) => response.json())
    },

    validateKey(key) {
        return Vue.http.get(config.apiBaseUrl + '/company-user-invites/validate-key/' + key).then((response) => response.json())
    },

    acceptInvite(key, body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/company-user-invites/accept-invite/' + key, body, { params }).then((response) => response.json())
    }
}
